// extracted by mini-css-extract-plugin
export default {"component__action":"table-component_component__action_TZCdk","component":"table-component_component_AbVIA"};